import { useTranslation } from 'react-i18next'
import { type FetchedExternalInsuranceFragment } from '@/services/graphql/generated'
import { Button } from 'ui/src/components/Button/Button'
import { BaseDialog } from 'ui/src/components/Dialog/BaseDialog'
import { yStack } from 'ui/src/patterns/stack'
import { EmptyFetchedInsurancesContent } from './EmptyFetchedInsurancesContent'
import { FetchedInsurancesContent } from './FetchedInsurancesContent'
import { useFetchInsurance } from './useFetchInsurance'

type Props = {
  insurances: Array<FetchedExternalInsuranceFragment>
  externalInsurerName: string
  onConfirm: () => void
}

export function FetchedInsurancesListDialog({ insurances, externalInsurerName, onConfirm }: Props) {
  const { t } = useTranslation('purchase-form')
  const { state, confirmResults } = useFetchInsurance()

  const hasFetchedInsurances = insurances.length > 0

  const handleConfirm = () => {
    confirmResults()
    onConfirm()
  }

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      handleConfirm()
    }
  }

  return (
    <BaseDialog.Root open={state === 'RESULTS'} onOpenChange={handleOpenChange}>
      <BaseDialog.Overlay frosted>
        <BaseDialog.Content className={yStack({ gap: 'md', padding: 'md', paddingTop: 'lg' })} maxWidth="23.5rem">
          {hasFetchedInsurances ? (
            <FetchedInsurancesContent insurances={insurances} />
          ) : (
            <EmptyFetchedInsurancesContent externalInsurerName={externalInsurerName} />
          )}

          <Button variant="primary" size="large" fullWidth onClick={handleConfirm}>
            {t('FETCHED_INSURANCES_DIALOG_CONFIRM_BUTTON')}
          </Button>
        </BaseDialog.Content>
      </BaseDialog.Overlay>
    </BaseDialog.Root>
  )
}
